
import { useState } from "react";
import { FileService } from "../../../../../../core/services/FileService";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import useModal, { MODAL_md, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { SelectWorkActivityGroupByIDAvtivity } from "../../../../WorkActivityGroup/SelectWorkActivityGroupByIDAvtivity";
import { useBoardManager } from "../../../BoardsManagerProvider";
import "./ActivityCard.css";
import { ActivityCardInfo } from "./ActivityCardInfo/ActivityCardInfo";
import { SelectWorkActivityGroupUserByIDAccount } from "../../../../WorkActivityGroup/WorkActivityGroupUser/SelectWorkActivityGroupUserByIDAccount";
import { SelectWorkActivityGroup } from "../../../../WorkActivityGroup/SelectWorkActivityGroup";
import { SelectWorkActivityGroupByIDSprint } from "../../../../WorkActivityGroup/SelectWorkActivityGroupByIDSprint";

export const ActivityCard = ({ activity }) => {

    const { assingWorkActivity, IDAccount } = useBoardManager();

    const fileService = new FileService();
    const p = activity.DataBeanProperties;

    const modal = useModal(`${p.WorkActivityCode ?? ""} - ${p.Name ?? ""}`, MODAL_XL)
    const modalAsing = useModal(`Re Asignar ${p.Name}`, MODAL_md)

    const photo: string = p.AccountPhoto ? fileService.getUrlFile("photos", p.AccountPhoto) : "";
    const statusColor = p.StatusesCardColor || "var(--bs-secondary, #f5741e)";

    const [update, setUpdate] = useState({
        IDGroup: null,
        IDEmployee: null,
    })

    return (
        <>
            <div
                draggable
                className="activity-card"
                style={{
                    "--status-color": statusColor
                } as React.CSSProperties}
                onDragStart={(e) => {
                    e.dataTransfer.setData(
                        "activityId",
                        p.IDWorkActivity.toString()
                    );
                }}
                onClick={() => { modal.open() }}
            >
                <div className="activity-card__header">
                    <span className="activity-card__code">
                        {p.WorkActivityCode}
                    </span>

                    <span className="activity-card__type">
                        {p.ActivityTypeName}
                    </span>
                </div>

                {/* TITLE */}
                <div className="activity-card__name">
                    {p.Name}
                </div>

                {/* FOOTER */}
                <div className="activity-card__footer">

                    <span className="activity-card__user">
                        <img
                            src={photo != "" ? photo : "./public/assets/images/core/avatar.png"}
                            alt="profile_img"
                            className="activity-card__avatar"
                        />
                        {p.AccountFullName ?? "S/A"}
                    </span>

                    <span className="activity-card__priority">
                        ⚡ {p.PriorityName}
                    </span>

                </div>

            </div>

            <Modal modal={modal.modal} updateModal={modal.setModal} buttonsAddFooter={
                <>
                    <BasicButton eventClick={() => { modalAsing.open() }} icon="ri-user-shared-2-line" children={`Re-Asignar Tarea`} />
                </>
            } >
                <ActivityCardInfo WorkActivity={p} />

                <Modal modal={modalAsing.modal} updateModal={modalAsing.setModal} eventModal={() => { (assingWorkActivity(p.IDWorkActivity, update.IDEmployee, () => { modal.close(); modalAsing.close(); setUpdate({ IDEmployee: null, IDGroup: null }) })) }} >
                    <div className="row">
                        <div className="col-md-12">
                            {IDAccount ?
                                <SelectWorkActivityGroupByIDSprint label="Areas Disponibles" IDSprint={p.IDSprint} idSelector={update.IDGroup} onChange={(e) => { setUpdate({ ...update, IDGroup: e }) }} />
                                :
                                <SelectWorkActivityGroup  idSelector={update.IDGroup} onChange={(e) => { setUpdate({ ...update, IDGroup: e }) }} label="Grupos de Trabajo" />
                            }
                        </div>
                        {update.IDGroup &&
                            <div className="col-md-12">
                                <SelectWorkActivityGroupUserByIDAccount label="Nuevo Responsable" idGroup={update.IDGroup} idSelector={update.IDEmployee} onChange={(e) => { setUpdate({ ...update, IDEmployee: e }) }} />
                            </div>
                        }
                    </div>
                </Modal>
            </Modal>

        </>
    );
};